import { connect } from 'react-redux';

import { ApplicationState } from '@mews-commander/types';
import { ContentCard, ResponsiveTwoColumns, ReadOnly, FormMeta, FormMetaSection } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import CreditLimitForm from '../../../../creditLimit/components/CreditLimitForm';
import { CompanyDetailForms } from '../../../enums';
import { getCompanyFormattedMeta } from '../../../selectors';
import { AdditionalInfoForm } from '../../Forms';

interface StateProps {
    meta: FormMeta;
}

type AdditionalInfoTabProps = Identifiable & StateProps;

const AdditionalInfoTab = ({ id, meta }: AdditionalInfoTabProps) => {
    const strawberryReadOnlyFieldsEnabled = useFeatureFlag(FeatureFlag.strawberryReadOnlyFieldsEnabled);
    return (
        <ResponsiveTwoColumns>
            <ContentCard title={<LocalizedText textKey={TextKey.AdditionalInfo} />}>
                <Stack vertical spacing="200">
                    <ReadOnly name="identifier" label={<LocalizedText textKey={TextKey.Identifier} />} value={id} />
                    <FormMetaSection meta={meta} />

                    {/* @ts-expect-error featureFlagService is provided by redux, however due to mixing zod with redux it breaks typescript */}
                    <AdditionalInfoForm
                        form={CompanyDetailForms.AdditionalInfoForm}
                        id={id}
                        strawberryReadOnlyFieldsEnabled={strawberryReadOnlyFieldsEnabled}
                    />
                </Stack>
            </ContentCard>
            <ContentCard title={<LocalizedText textKey={TextKey.CreditLimit} />}>
                <CreditLimitForm
                    form={CompanyDetailForms.CreditLimitsForm}
                    accountId={id}
                    strawberryReadOnlyFieldsEnabled={strawberryReadOnlyFieldsEnabled}
                />
            </ContentCard>
        </ResponsiveTwoColumns>
    );
};
// @ts-expect-error $TSFixMeError: Argument of type '(state: ApplicationState, { id }: Identifiable<string>) => { meta: { creatorName: unknown; updaterName...
export default connect<StateProps, {}, Identifiable, ApplicationState>((state, { id }) => ({
    meta: getCompanyFormattedMeta(state, { id }),
}))(AdditionalInfoTab);
